import { makeStyles } from "@fluentui/react-components";
export const usePlanTasksBoardViewStyles = makeStyles({
    projectManagerLogo: {
        height: "28px",
        width: "28px"
    }
});
